import { cmsApiFetch } from "./lib/cmsApiFetch";
import envVariables from "./lib/envVariables";

class MockClient {
  fetch = async <T>(query: string): Promise<T> => {
    const url = new URL(`${envVariables.CMS_API_BASE_URL}/api/query`);
    url.searchParams.set("query", query);
    return cmsApiFetch<T>(url);
  };
}
export default new MockClient();
